import template from './insuranceFiles.html';
import controller from './insuranceFilesCtrl.js';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    familyId: '<',
    familyFullName: '<',
  },
};
